import { Constantes } from "../constants/constantsGlobal";
import { iProjectDatacenterStoragePag, iProjectDatacenterStorageRow } from "../models/interfaceDatacenterStorage";
import { iResponse } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";

   
export const chatbotProjectDatacenter = async ( request:iProjectDatacenterStoragePag , user: any, setUser: (user: any) => void): Promise<iResponse> => {
   try { 
    // es el datacenter_id/file_id 
    const url = `${Constantes.URI_ChatBotDatacenterStorage}/${request.datacenter_id}/${request.file_id}?${ request.query.trim()? ("query="+request.query.trim()+"&"):""}limit=${request.pageSize}&page=${request.page}`
    const response = await setupInterceptor( url, user, setUser, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }); 
    if (!response.ok) {
      throw new Error(`Error en la solicitud: ${response.statusText}`);
    }
    const data: iResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error al obtener datos:", error);
    throw error;
  }
};



   // https://gtw-dp-b72612lc.uc.gateway.dev/api/chatbotmngt-datacenter/datastore/lJLkPT7fOEcXO4Muyvht/pQ6Rs8IzhXjgO15JhGUl/gfCBcsC2LFVO7y4hfoJX
   //let url = MODULE + CONTROLLER + `/${file_id}/${datacenter_id}/${row_id}`;
export const chatbotProjectDatacenterRow = async ( request:iProjectDatacenterStorageRow , user: any, setUser: (user: any) => void): Promise<iResponse> => {
  try { 
   const url = `${Constantes.URI_ChatBotDatacenterStorage}/${request.file_id}/${request.datacenter_id}/${request.row_id}`
   const response = await setupInterceptor( url, user, setUser, {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
     },
     body: JSON.stringify(request.data),  
   }); 
   if (!response.ok) {
     throw new Error(`Error en la solicitud: ${response.statusText}`);
   }
   const data: iResponse = await response.json();
   return data;
 } catch (error) {
   console.error("Error al obtener datos:", error);
   throw error;
 }
};

